import { render, staticRenderFns } from "./tongueTriangleN.vue?vue&type=template&id=e3528182&"
import script from "./tongueTriangleN.vue?vue&type=script&lang=js&"
export * from "./tongueTriangleN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports